export default `#ifdef GL_ES
  precision highp float;
#endif

varying float vHeight;
uniform vec3 u_palette[5];
uniform float opacity_threshold_table[4];
uniform float base_opacity;

void main(){
  
  float band = step(abs(opacity_threshold_table[0]), abs(vHeight))
      + step(abs(opacity_threshold_table[1]), abs(vHeight))
      + step(abs(opacity_threshold_table[2]), abs(vHeight))
      + step(abs(opacity_threshold_table[3]), abs(vHeight));

  
  vec3 color = u_palette[0];
  color = mix(color, u_palette[1], step(abs(opacity_threshold_table[0]), abs(vHeight)));
  color = mix(color, u_palette[2], step(abs(opacity_threshold_table[1]), abs(vHeight)));
  color = mix(color, u_palette[3], step(abs(opacity_threshold_table[2]), abs(vHeight)));
  color = mix(color, u_palette[4], step(abs(opacity_threshold_table[3]), abs(vHeight)));

  
  
  
  float fadeExponent = mix(2.0, 1.0, band / 4.0);
  float alpha = pow(base_opacity, fadeExponent);

  gl_FragColor = vec4(color, alpha);
}`